import React from 'react'
import Title from '../components/Title'
import Input from '../components/Input'
import Button from '../components/Button'
import { useState } from 'react'


const InquiryForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        company: "",
        mobile: "",
        email: "",
        subject: "",
        message: "",
    });

    const [responseMessage, setResponseMessage] = useState("");

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch("https://betalinkquate.ecomuntant.com/api/testformdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setResponseMessage("Your inquiry has been submitted successfully!");
                setFormData({
                    name: "",
                    company: "",
                    mobile: "",
                    email: "",
                    subject: "",
                    message: "",
                });
            } else {
                setResponseMessage("Error submitting the inquiry. Please try again.");
            }
        } catch (error) {
            console.error("Error:", error);
            setResponseMessage("Something went wrong. Please try again.");
        }

    };

    return (
        <div className="App mt-3 mb-3 md-mt-5 md-mb-5">
            <div className='main_wrapper back_clr'>
                <div className='form_design pt-3 pb-3'>
                    <div className='container'>
                        <div className='section_main_title d-flex align-items-center justify-content-between'>
                            <Title text="SUBMIT YOUR QUERY." className="custom-heading" />
                            <ul className='d-flex align-items-center'>
                                <li className='orange'>Reach Out for Expert Guidance </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-md-7'>
                            <div className='inquery_form'>
                                {responseMessage && <p>{responseMessage}</p>}
                                <form onSubmit={handleSubmit} className='row'>
                                    <div className='col-md-6'>
                                        <Input label="Name:" name="name" value={formData.name} onChange={handleChange} required />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input label="Company:" name="company" value={formData.company} onChange={handleChange} required />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input label="Mobile:" name="mobile" value={formData.mobile} onChange={handleChange} required />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input label="Email:" type="email" name="email" value={formData.email} onChange={handleChange} required />
                                    </div>
                                    <div className='col-md-12'>
                                        <Input label="Subject:" name="subject" value={formData.subject} onChange={handleChange} />
                                    </div>
                                    <div className='col-md-12'>
                                        <Input label="Your Message:" name="message" value={formData.message} onChange={handleChange} required isTextarea />
                                    </div>
                                    <div className='submit_btn mt-4'>
                                        <Button type="submit">Submit</Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className='col-md-5 mbl-hide'>
                            <div className='left_side_img'>
                                <img src='images/statement-right.png' className='img_width' alt='form design'></img>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InquiryForm;